module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.1.1Rc.3 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/cell.html"
    }
  }, [_vm._v("Cell")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add font-size variable #990 @wg5945")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/swiper.html"
    }
  }, [_vm._v("Swiper")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix nodes list forEach function is undefined #991 @howyhuang")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-button.html"
    }
  }, [_vm._v("XButton")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix no loading style if not using Loading component #986 @malaimoo")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/ajax.html"
    }
  }, [_vm._v("Ajax")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Export http on Vue")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/wechat.html"
    }
  }, [_vm._v("Wechat")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Export wechat on Vue")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c5b3a2e6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-c5b3a2e6"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.1.1-rc.3-92.vue
// module id = 3010
// module chunks = 373